import axios from "@/plugins/axios/config";

export default {
    getCaptcha() {
        return axios.get('captcha');
    },
    verifyCaptcha(params) {
        return axios.get('validate/recaptcha', { params });
    }
};
